export class LoadProjectPHPSettingsError extends Error {}
